import './page/coman-consent-manager-configuration'

const { Module } = Shopware;

Module.register('coman-consent-manager-configuration', {
    color: '#96588a',
    icon: 'default-shopping-paper-bag-product',
    title: 'coman.title',
    description: 'coman.description',
    routes: {
        index: {
            component: 'coman-consent-manager-configuration',
            path: 'index'
        }
    },
    settingsItem: {
        name: "coman-consent-manager-configuration",
        group: 'plugins',
        to: 'coman.consent.manager.configuration.index',
        iconComponent: 'coman-consent-manager-settings-icon',
        privilege: 'system.system_config',
        color: '#96588a'
    },
})
